<template>
	<div class="wrap">
		<van-nav-bar
			:title="title"
			@click-left="clickNavBack"
			left-arrow
			id="reset"
			:border="false"
		></van-nav-bar>
		<div style="margin: 20px;padding: 8px;border-radius: 10px;background-color: #f5f5f5;" v-if="topicList.length > 0">
			<van-cell-group :title="groupTitle" inset style="margin-bottom: 15px">
				<van-cell
					v-for="item in topicList"
					:key="item.id"
					:title="item.name"
					icon="points"
					is-link
					:value="'共' + item.questionTotal + '题'"
					@click="topicView(item)"
				/>
			</van-cell-group>
		</div>
		<van-empty :description="emptyText" v-else />
	</div>
</template>

<script>
import {
	getTargetedChapters,
	getTargetedKnowledgePoints,
	getTargetedLocalQuestions,
	getTargetedSpecials,
	getTargetedWrongQuestions
} from '@/api/user'

export default {
	name: 'viptargetedlist',
	data() {
		return {
			title: this.$route.query.title || '专项练习',
			topicList: []
		}
	},
	computed: {
		issubject() {
			return this.$route.query.subject
		},
		categoryId() {
			return this.$route.query.categoryId
		},
		cityCode() {
			return this.$route.query.cityCode
		},
		appNo() {
			return JSON.parse(localStorage.getItem('loginInTKfor_APP02')) === null ? '' : sessionStorage.getItem('appno') || 'APP02'
		},
		token() {
			return JSON.parse(localStorage.getItem('loginInTKfor_APP02')) === null ? '' : JSON.parse(localStorage.getItem('loginInTKfor_APP02')).token
		},
		type() {
			return this.$route.query.type
		},
		groupTitle() {
			return this.title + '列表'
		},
		emptyText() {
			return '暂无可练习题目'
		}
	},
	created() {
		this.loadTopicList()
	},
	methods: {
		clickNavBack() {
			this.$router.go(-1)
		},
		loadTopicList() {
			const apiMap = {
				knowledge: () => getTargetedKnowledgePoints(this.categoryId, this.issubject, this.token),
				chapter: () => getTargetedChapters(this.categoryId, this.issubject, this.token),
				local: () => getTargetedLocalQuestions(this.categoryId, this.issubject, this.cityCode, this.token),
				wrong: () => getTargetedWrongQuestions(this.categoryId, this.issubject, this.token),
				special: () => getTargetedSpecials(this.categoryId, this.issubject, this.token)
			}
			const loader = apiMap[this.type]
			if (!loader) {
				this.topicList = []
				return
			}
			loader().then(res => {
				this.topicList = res || []
			})
		},
		topicView(item) {
			sessionStorage.setItem('favorites', JSON.stringify({ExercisesId: item.questionIds}))
			this.$router.push({
				path: '/vipfavilist',
				query: {
					subject: this.issubject,
					categoryId: this.categoryId,
					appNo: this.appNo,
					title: item.name
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.van-nav-bar {
	background-color: #2db1ac !important;
}

::v-deep .van-nav-bar .van-icon {
	color: #fff;
}

::v-deep .van-ellipsis {
	color: #fff;
}

.wrap {
	position: relative;
	min-height: 100vh;
	background: #f7f8fa;
}
</style>
